import type { ContactDataManagementFeatureConfig } from './type';

export const contactDataManagement: ContactDataManagementFeatureConfig = {
    address: {
        countrySelect: false,
        maxCityLength: 35,
        maxStreetLength: 35,
        poBoxType: false,
        streetNumberField: false,
        additionalFields: false,
        countyField: false,
        streetTypeField: false,
        streetTypeSelect: false,
    },
    addressDeleteDelayAlert: false,
    changeNotEditableContactMessengerTopicId: undefined,
    mainContactSetting: false,
    phone: {
        summaryFormat: 'NATIONAL',
        typeValidation: true,
    },
    alwaysSetNewContactAsMain: false,
    legacy: {
        editAndViewHandover: false,
        useLegacyApiOnlyForViewContacts: false,
    },
    proofOfAddressExternalApplication: false,
    operationAgnosticSigningEnabled: false,
};
